// @ts-nocheck

import { range } from 'lodash';

import networkActions from '../actions/network';
import { MultiviewStyles } from '../constants/multiview';
import { MultiviewActionTypes } from '../types/actions/multiview';
import { MultiviewDisplayModes } from '../types/multiview';
import { Routes } from '../types/routes';

const updateMatchList = () => (dispatch, getState) => {
  const {
    multiview: { list },
  } = getState();
  dispatch(
    networkActions.send(
      {
        multiMatches: list,
      },
      {
        debounce: {
          time: 1000,
          options: {
            trailing: true,
          },
        },
      },
    ),
  );
};

export const setDisplayMode = (mode) => ({
  type: MultiviewActionTypes.SET_DISPLAY_MODE,
  payload: {
    mode,
  },
});

export const setItemPerLine = (itemPerLine) => ({
  type: MultiviewActionTypes.SET_ITEM_PER_LINE,
  payload: {
    itemPerLine,
  },
});

export const setUserOption = (userOption) => ({
  type: MultiviewActionTypes.SET_USER_OPTION,
  payload: {
    userOption,
  },
});

export const addMatch = (matchId) => (dispatch, getState) => {
  const {
    multiview: { list },
  } = getState();
  // Verifie que le match n'est pas deja dans la liste
  if (list.indexOf(matchId) === -1) {
    // Add match
    dispatch({
      type: MultiviewActionTypes.ADD_MATCH,
      payload: { matchId },
    });
    // Get the new list
    const {
      multiview: { list: nextList },
    } = getState();
    // And subscribe
    dispatch(updateMatchList());
    // Si y a des matchs on passe en mode expanded !
    if (nextList.length > 0) {
      dispatch(setDisplayMode(MultiviewDisplayModes.EXPANDED));
    }
  }
};

export const delMatch = (matchId) => (dispatch, getState) => {
  const {
    multiview: { list },
  } = getState();
  // Verifie que le match est dans la liste
  if (list.indexOf(matchId) !== -1) {
    dispatch({
      type: MultiviewActionTypes.DEL_MATCH,
      payload: { matchId },
    });
    // Subscribe
    dispatch(updateMatchList());
  }
};

export const setShowMatchList = (value) => {
  return {
    type: MultiviewActionTypes.SET_SHOW_MATCH_LIST,
    payload: {
      value,
    },
  };
};

export const setDisplayOptions = (availableWidth) => (dispatch) => {
  const maxItemPerLine = Math.max(1, Math.floor(availableWidth / MultiviewStyles.MIN_WIDTH_CARD));
  const availableOptions = range(1, Math.min(6, Math.max(6, maxItemPerLine)));
  dispatch({
    type: MultiviewActionTypes.SET_DISPLAY_OPTIONS,
    payload: {
      value: availableOptions,
    },
  });
  dispatch(setItemPerLine(maxItemPerLine));
};

export const setScrollToHeaderOnTheNextShowMatchList = (value) => ({
  type: MultiviewActionTypes.SET_SCROLL_TO_HEADER,
  payload: {
    value,
  },
});

export const onUnmountMultiview = () => (dispatch) => {
  dispatch(setDisplayMode(MultiviewDisplayModes.NORMAL));
  dispatch(setScrollToHeaderOnTheNextShowMatchList(false));
};

export const onMountMultiview = () => (dispatch) => {
  dispatch(setDisplayMode(MultiviewDisplayModes.EXPANDED));
  dispatch(setScrollToHeaderOnTheNextShowMatchList(true));
  dispatch(networkActions.send({ route: Routes.MULTIVIEW, data: true }));
  dispatch(updateMatchList());
};

export const saveToStorage = () => ({
  type: MultiviewActionTypes.SAVE_TO_STORAGE,
  meta: { debounce: { time: 250 } },
});
